import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { ServiceGrid } from './components/ServiceGrid';
import { MenuExperience } from './components/MenuExperience';
import { Footer } from './components/Footer';
import { QuoteModal } from './components/QuoteModal';
import { ServiceDetail } from './pages/ServiceDetail';
import { Gallery } from './components/Gallery';
import { Contact } from './pages/Contact';
function HomePage({
  openQuote
}: {
  openQuote: (item?: string) => void;
}) {
  return <>
      <Hero onOpenQuote={() => openQuote()} data-id="element-0" />
      <Story data-id="element-1" />
      <ServiceGrid onOpenQuote={service => openQuote(service)} data-id="element-2" />
      <MenuExperience onSelectItem={item => openQuote(item)} data-id="element-3" />
      <Gallery data-id="element-4" />
    </>;
}
function ServicesPage({
  openQuote
}: {
  openQuote: (item?: string) => void;
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24 min-h-screen bg-gray-50" data-id="element-5">
      <ServiceGrid onOpenQuote={openQuote} data-id="element-6" />
    </div>;
}
function MenuPage({
  openQuote
}: {
  openQuote: (item?: string) => void;
}) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24 min-h-screen bg-white" data-id="element-7">
      <MenuExperience onSelectItem={openQuote} data-id="element-8" />
    </div>;
}
function StoryPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-24 min-h-screen bg-white" data-id="element-9">
      <Story data-id="element-10" />
    </div>;
}
function ContactPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="pt-32 pb-24 min-h-[60vh] bg-gray-50 flex flex-col items-center justify-center px-6 text-center" data-id="element-11">
      <h1 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-12">Get in Touch</h1>
      <p className="text-gray-600 max-w-2xl mb-8" data-id="element-13">
        We would love to hear from you. Whether you're planning a grand wedding
        or a corporate luncheon, our team is ready to bring your vision to life.
      </p>
      <div className="flex flex-col md:flex-row gap-8 text-left" data-id="element-14">
        <div className="bg-white p-8 rounded-sm shadow-sm border border-gray-100 w-full md:w-64" data-id="element-15">
          <h3 className="font-bold text-brand-black mb-2" data-id="element-16">Email Us</h3>
          <p className="text-gray-500" data-id="element-17">hello@versatilityeats.com</p>
        </div>
        <div className="bg-white p-8 rounded-sm shadow-sm border border-gray-100 w-full md:w-64" data-id="element-18">
          <h3 className="font-bold text-brand-black mb-2" data-id="element-19">Call Us</h3>
          <p className="text-gray-500" data-id="element-20">(202) 555-0123</p>
        </div>
      </div>
    </div>;
}
export function App() {
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<string | undefined>(undefined);
  const openQuote = (item?: string) => {
    setSelectedItem(item);
    setIsQuoteModalOpen(true);
  };
  return <BrowserRouter data-id="element-21">
      <div className="min-h-screen flex flex-col" data-id="element-22">
        <Header onOpenQuote={() => openQuote()} data-id="element-23" />
        <main className="flex-grow" data-id="element-24">
          <Routes data-id="element-25">
            <Route path="/" element={<HomePage openQuote={openQuote} data-id="element-27" />} data-id="element-26" />
            <Route path="/services" element={<ServicesPage openQuote={openQuote} data-id="element-29" />} data-id="element-28" />
            <Route path="/menu" element={<MenuPage openQuote={openQuote} data-id="element-31" />} data-id="element-30" />
            <Route path="/story" element={<StoryPage data-id="element-33" />} data-id="element-32" />
            <Route path="/contact" element={<Contact data-id="element-35" />} data-id="element-34" />
            <Route path="/services/:id" element={<ServiceDetail openQuote={openQuote} data-id="element-37" />} data-id="element-36" />
          </Routes>
        </main>
        <Footer data-id="element-38" />
        <QuoteModal isOpen={isQuoteModalOpen} onClose={() => setIsQuoteModalOpen(false)} initialItem={selectedItem} data-id="element-39" />
      </div>
    </BrowserRouter>;
}